import { server } from '@api/request';
import { ApiKey, LambdaLog } from '@models';
import { isObject } from '@tools/type-guards';

// List ApiKeys
/**
 * List all Api Keys
 *
 * @return A list of ApiKeys
 */
export async function apiKeysList() {
  return await server.list('v2/admin/developer/api-keys', processApiKeyData);
}

export interface CreateApiKeyOptions {
  name: string;
  permissions: string[];
  userId?: string;
  organizationId?: string;
}

export async function createApiKey(options: CreateApiKeyOptions) {
  return await server.post('v2/admin/developer/api-keys', options);
}

export interface UpdateApiKeyOptions {
  apiKey: string;
  name?: string;
  permissions?: string[];
  active?: boolean;
}

export interface RevokeApiKeyOptions {
  apiKey: string;
  active: false;
}

export async function updateApiKey(options: UpdateApiKeyOptions) {
  return await server.post('v2/admin/developer/api-keys/update', options);
}

//#region Helper Functions
/**
 *
 */
function isValidApiKeyData(value: unknown): value is ApiKey {
  if (!isObject(value)) return false;

  // TEMP: Use a more strict validation.

  return true;
}

/**
 * Search for lambda logs by a specified criteria (paginated).
 *
 * @param options Request options payload.
 *
 */
export interface LambdaLogsSearchOptions {
  functionName: string;
  level?: 'info' | 'error' | 'warn';
  order?: 'ASC' | 'DESC';
  limit?: number;
  startDate?: string;
  endDate?: string;
  startKey?: ZephyrWeb.Pagination.PlacementKey;
}

export interface LambdaLogsSearchResults {
  items: LambdaLog[];
  lastEvaluatedKey?: ZephyrWeb.Pagination.PlacementKey;
}

/**
 * Search for lambda logs by a specified criteria (paginated).
 *
 * @param options Request options payload.
 * @returns Search {@link LambdaLogsSearchResults results} data object.
 */
export async function searchLambdaLogs(options: LambdaLogsSearchOptions) {
  return await server.post('v2/admin/developer/lambda/logs/search', options, processLambdaLogData);
}

function processLambdaLogData(data: unknown) {
  if (!isValidLambdaLogData(data)) {
    throw new Error('Invalid lambda log data item.');
  }

  return data;
}

function isValidLambdaLogData(value: unknown): value is LambdaLogsSearchResults {
  if (!isObject(value)) return false;

  // TEMP: Use a more strict validation.

  return true;
}

/**
 *
 */
function processApiKeyData(data: unknown) {
  if (!isValidApiKeyData(data)) {
    throw new Error('Invalid api keydata item.');
  }

  // process server data to client data
  return { ...data, issuedDate: data.issued ? new Date(data.issued).toISOString() : null, expirationDate: data.expiration ? new Date(data.expiration).toISOString() : null } as ApiKey;
}
